module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recommendationsnotavailable.higherplan":"Some recommendations are not available on your current subscription, contact","recommendationsnotavailable.salesteam":"sales team"}}')
  delete Component.options._Ctor
}
